"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useDisableBodyScroll(open, options) {
    var scrollable = options === null || options === void 0 ? void 0 : options.scrollable;
    var bodyOverflow = (0, react_1.useRef)('');
    var bodyPaddingRight = (0, react_1.useRef)('');
    (0, react_1.useEffect)(function () {
        if (scrollable)
            return;
        var restoreStyle = function () {
            document.body.style.overflow = bodyOverflow.current;
            document.body.style.paddingRight = bodyPaddingRight.current;
        };
        if (open) {
            var scrollbarWidth = window.innerWidth - document.body.clientWidth;
            var bodyStyle = document.body.style;
            // store previous style
            bodyOverflow.current = bodyStyle.overflow;
            bodyPaddingRight.current = bodyStyle.paddingRight;
            // prevent scrolling when modal is open
            bodyStyle.overflow = "hidden";
            // prevent layout shift
            bodyStyle.paddingRight = scrollbarWidth + "px";
        }
        else {
            restoreStyle();
        }
        // when unmount
        return restoreStyle;
    }, [open, scrollable]);
}
exports.default = useDisableBodyScroll;
